<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Goods/index.html')">商品管理</div></el-breadcrumb-item>
            <el-breadcrumb-item>供应商-商品审核</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs v-model="item.authStatus" type="card" @tab-click="changeActive">
            <el-tab-pane name="0">
                <span slot="label">待审核</span>
            </el-tab-pane>
            <el-tab-pane name="2">
                <span slot="label">已驳回</span>
            </el-tab-pane>
        </el-tabs>
        <el-form :inline="true" :model="item" class="search">
            <el-form-item label="商品名称">
                <el-input v-model="item.name" placeholder="请输入商品名称" size="small"></el-input>
            </el-form-item>
            <el-form-item label="商品分类">
                <el-cascader v-model="item.product_category_id" placeholder="请选择"
                             :options="optionsProduct" :props="filterProps" clearable></el-cascader>
            </el-form-item>
            <el-form-item label="所属供应商">
                <el-select v-model="item.supplier_id" clearable placeholder="所属供应商" size="small">
                    <el-option v-for="item in options_supplier" :key="item.value" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" size="medium">查询</el-button>
            </el-form-item>
        </el-form>
        <div class="btns">
            <el-button type="danger" size="small" @click="auditAll" v-auth="['admin/product/audit']">批量审核</el-button>
        </div>
        <el-table :data="list" border @selection-change="handleSelectionChange">
            <!--			这里 prop scope传值-->
            <el-table-column type="selection" align="center"></el-table-column>
            <!-- <el-table-column width="60" align="center">
                <template slot-scope="scope">
                    {{scope.$index + (page-1) * pageSize + 1}}
                </template>
            </el-table-column> -->
			<el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column label="商品图片">
                <!--				商品的组件和插槽-->
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                        <img :src="scope.row.product_pic_main" height="30" style="display: flex; margin-right: 5px;"/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="productcategory" label="商品分类">
                <template slot-scope="scope" v-if="scope.row.productcategory">
                    {{scope.row.productcategory.name}}
                </template>
            </el-table-column>
            <el-table-column label="供应商">
                <template slot-scope="scope">
                    <span v-if="scope.row.supplier">{{scope.row.supplier.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
                <!--			价格模板插槽	-->
                <template slot-scope="scope">
                    <el-tag size="small" type="success" v-if="scope.row.is_marketable">
                        已上架
                    </el-tag>
                    <el-tag size="small" type="danger" v-else>
                        已下架
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="审核状态" align="center">
                <!--			价格模板插槽	-->
                <template slot-scope="scope">
                    <el-tag size="small" type="success" v-if="scope.row.auth_status == 0">
                        待审核
                    </el-tag>
                    <el-tag size="small" type="success" v-if="scope.row.auth_status == 1">
                        已通过
                    </el-tag>
                    <el-tag size="small" type="danger" v-if="scope.row.auth_status == 2">
                        已驳回
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="created_date" label="添加时间" align="center"></el-table-column>
            <el-table-column prop="last_modified_date" label="更新时间" align="center"></el-table-column>

            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <!--					传ID过去修改-->
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/product/audit']">
                        审核
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--		页码-->
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                       :current-page.sync="pageNum"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="limit"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        <el-dialog title="批量审核" :visible.sync="dialogBatchAgreeVisible" width="30%">
			<span>
				<span style="display: flex;align-items: center;margin-top: 20px;">
					<span style="flex-shrink: 0;margin-right: 10px;">提价金额(元)</span>
					<el-input v-model="platform_add_price" placeholder="提价金额" style="flex-grow: 1;"></el-input>
				</span>
			</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="sureSub">确 定</el-button>
			</span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'Menu',
        data() {
            return {
                // 商品数据
                list: [],
                isLoad: false,
                pageNum: 0,
                limit: 20,
                total: 0,
                page: 1,
                thumb: [],
                // 查询
                item: {
                    authStatus: 0
                },
                options_supplier: [],
                optionsProduct: [],
                filterProps: {
                    value: 'id',
                    label: 'name',
                    emitPath: false,
                    checkStrictly: true
                },
                dialogBatchAgreeVisible: false,
                platform_add_price: 0
            }
        },
        created() {
            this.item = {
                page: this.page,
                limit: this.limit,
                authStatus: 0
            }
            this.getData()
            this.loadList()
        },
        methods: {
			gotopage(url){
				console.log(url);
				var link =  this.$router.resolve({
				    path: url,
					query: {
						page: this.item.page
					}
				});
				window.open(link.href, '_blank')
			},
            changeActive: function (tab, event) {
                this.item.page = 1
                this.loadList()
            },
            getData() {
                this.axios.post('/admin/supplier/list', {}).then(res => {
                    this.options_supplier = res.data.list;
                    return this.axios.get('/admin/data/getCategoryTreeAdmin', {})
                }).then(res => {
                    this.optionsProduct = res.data.list
                })
            },
            // 获取数据
            loadList() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
				if(this.$route.query.page>0){
					this.item.page =  this.$route.query.page
					this.pageReload(this.$route.query.page)
				}
                //	将页码传到/Goods/index
                this.axios.post('/admin/product/listForSupplierPass', this.item
                )
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 后端返回的商品数据列表
                        this.list = res.data.list.data
                        this.total = res.data.list.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },

            // 带着商品ID跳转
            edit(id) {
                // 使用路由的resolve方法
                const link = this.$router.resolve({
                    path: '/GoodsAudit/edit.html',
                    query: {
                        id: id,
						page: this.item.page
                    }
                })
                window.open(link.href, '_self')
            },
            auditAll: function () {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }

                if (id.length == 0) {
                    return this.$message.error('请选择商品')
                }
                this.platform_add_price = 0
                this.dialogBatchAgreeVisible = true
            },
            sureSub() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (id.length == 0) {
                    return this.$message.error('请选择商品')
                }

                this.axios.post('/admin/product/auth', {
                    id: id,
                    authStatus: 1,
                    platform_add_price: 0
                }).then(() => {
                    this.$message.success({
                        message: '操作成功'
                    });
                    this.dialogBatchAgreeVisible = false
                    this.loadList()
                })
            },
            del(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                // ajax删除 先将要删除数据的ID传过去  执行删除
                this.axios.delete('/admin/product/shopsProduct/delete', {
                    data: [
                        id
                    ]
                })
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '删除成功',
                            showClose: false
                        });
                        // 重新获取数据
                        this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAll() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/product/shopsProduct/delete', {
                    data: id
                }).then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose: false
                    });
                    this.loadList()
                })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            //sizeReload 共多少条为一页
            sizeReload(val) {
                this.item.limit = val
                this.loadList()
            },
            // 前往第几页
            pageReload(val) {
				this.$router.push('/GoodsAudit/supplierGoods.html');
				this.page = parseInt(val);
				this.item.page = parseInt(val);
				this.pageNum = parseInt(val);
                this.item = {
                		page: this.page,
                		limit: this.limit,
                		authStatus: 0
                },
                this.getData()
                this.loadList()
            },
            // 搜索查询
            submit() {
                this.pageNum = 1
                this.item.page = 1
                this.loadList()
            },
            // 导出
            excelOut() {
                return;
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.get('/Member/excelOut', {
                    params: {
                        nickname: this.item.nickname,
                        title: this.item.title
                    }
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 导出
                        window.open(res.url)
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        }
    }
</script>
<style scoped>
</style>
